import { BaseRequestModel } from "../BaseModel/BaseRequestModel";

export class getprocurementplanbyidexportRequestModel extends BaseRequestModel{
    planID:number
}